import React from 'react';

const Footer = () => (
  <div className="">
    <p className="p-8 text-xs text-center text-gray-700 bg-altBack">
      Copyright © {new Date().getFullYear()} Stamped.
      {/* <Link to="/" className="">
        Become An Affiliate.{' '}
      </Link> */}
    </p>
  </div>
);

export default Footer;
